export default __webpack_public_path__ + "static/media/arrow_forward.395e6820.svg";